import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import KeycloakService from "libs/keycloak";
import { getInReviewApp } from "../helpers/inReviewApp";

const prepareHeaders = async (headers: Headers) => {
  const _keycloak = await KeycloakService.getInstance();
  await _keycloak.updateToken(10);
  const token = _keycloak.token;

  if (token) {
    headers.set("authorization", `Bearer ${token}`);
  }
  return headers;
};

const createAsyncBaseQuery = (
  defaultBaseUrl: string,
  remoteConfigVar: string
): BaseQueryFn<string | FetchArgs, unknown, unknown> => {
  return async (args, api, extraOptions) => {
    const inReview = await getInReviewApp();

    const baseUrl = inReview?.[remoteConfigVar] || defaultBaseUrl;

    const baseQuery = fetchBaseQuery({
      baseUrl,
      prepareHeaders,
    });

    return baseQuery(args, api, extraOptions);
  };
};

const baseRouteApiQuery = createAsyncBaseQuery(
  process.env.REACT_APP_ROUTE_API_URL,
  "route_api_url"
);
const baseGeneratorApiQuery = createAsyncBaseQuery(
  process.env.REACT_APP_GENERATOR_API_URL,
  "generator_api_url"
);

export const routeApi = createApi({
  reducerPath: "routeApi",
  baseQuery: baseRouteApiQuery,
  endpoints: () => ({}),
  tagTypes: ["Collects"],
});

export const generatorApi = createApi({
  reducerPath: "generatorApi",
  baseQuery: baseGeneratorApiQuery,
  endpoints: () => ({}),
  tagTypes: ["Generators"],
});
